import React, {Component} from 'react';
import {Switch, Route, Redirect, withRouter} from 'react-router-dom';
import {connect, Provider as ReduxProvider} from 'react-redux';
import {Container, Col, Row} from 'reactstrap';

// import Header from '../../components/Header/Header';
import Navbar from '../../components/Header/Navbar';
import SideProfile from '../../components/SideProfile';
import DashboardBuyer from '../../components/DashboardBuyer';
import SellerDetail from '../../components/SellerDetail';
import Profile from '../../components/Profile';
import Schedule from '../../components/Schedule';
import History from '../../components/History';
import Chat from "../../components/Chat";
import Messages from "../../components/Messages";
import Message from "../../components/Message";
import MessageList from "../../components/MessageList";
import RequestList from "../../components/RequestList";
import ResponseList from "../../components/ResponseList";


import '../../styles/sideProfile.scss';

class Full extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.rehydrated) // wait until local storage is loaded to global state
        {
            return (<div>Please wait</div>);
        }
        if (this.props.rehydrated && !this.props.isAuthenticated) //this.state (local state) -> this.props
        {
            return (
                <Redirect to={{
                    pathname: "/signin"
                }}/>
            )
        } else {
            return (
                <div className="wrap">
                    <div className="app">
                        {/*<div className="d-flex">*/}
                        <Navbar/>
                        {/*<div className="d-flex justify-content-end">*/}
                        <Container fluid style={{"background-color":"lightpink"}}>
                        <Row>
                            {/*<Col md={3}  className="profile" style={{"display" : "flex", "align-items": "center", "justify-content": "center"}}>*/}
                            <Col md={2}  className="profile">
                                <SideProfile/>
                            </Col>
                            <Col md={1}></Col>
                            <Col md={8} className="content-right">
                                <Switch>
                                    <Route path="/dashboard/buyer" name="DashboardBuyer"
                                           component={DashboardBuyer}/>
                                    <Route path="/list/seller/detail/:name" name="SellerDetail"
                                           component={SellerDetail}/>
                                    <Route path="/dashboard/profile/:username" name="Profile"
                                           component={Profile}/>
                                    <Route path="/dashboard/schedule" name="Schedule"
                                           component={Schedule}/>
                                    <Route path="/dashboard/history" name="History"
                                           component={History}/>
                                    {/*<Route path="/dashboard/chat/:requestId" name="Chat"*/}
                                    {/*       component={Chat}/>*/}
                                    {/*<Route path="/dashboard/messages" name="Messages"*/}
                                    {/*       component={Messages}/>*/}
                                    <Route path="/dashboard/message/:msgId" name="Message"
                                           component={Message}/>
                                    <Route path="/dashboard/messages/list" name="MessageList"
                                           component={MessageList}/>
                                    <Route path="/dashboard/request" name="RequestList"
                                           component={RequestList}/>
                                    <Route path="/dashboard/response" name="ResponseList"
                                           component={ResponseList}/>

                                </Switch>
                            </Col>
                            <Col md={1}></Col>
                        </Row>
                        </Container>

                        {/*<div className="profile">*/}
                        {/*    /!*<SideProfile/>*!/*/}
                        {/*    <div className="profile-left-bg"/>*/}
                        {/*    /!*<div className="d-flex justify-content-around">*!/*/}
                        {/*    <div>*/}
                        {/*        <div className="app-body">*/}
                        {/*            <main className="main">*/}
                        {/*                */}
                        {/*                    /!*<div>ddd</div>*!/*/}
                        {/*                    */}
                        {/*                    */}
                        {/*                </Container>*/}
                        {/*            </main>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            );
        }
    }


}


function mapStateToProps(store) {
    return {
        isAuthenticated: store.auth.isAuthenticated,
        rehydrated: store.auth.rehydrated,
    };
}

export default withRouter(connect(mapStateToProps)(Full));
